module.exports = "/_next/static/images/avatar1-640c0a84a024620613a084f013c4f443.jpeg";